<app-hero image="hero/hero_plan.png" title="Planning de la journée">
  <span>De la cérémonie, au repas !</span>
</app-hero>
<div class="container-fluid">
    <div class="row">
        <div class="col-12 col-lg-5 img-container">
            <img class="coeur" src="coeur.png" alt="coeur">
        </div>
        <div class="row p-4 col-10 offset-1 offset-lg-0 col-lg-6 align-items-center content-container">

            <div class="col-12 col-sm-3">
                <img class="planning-icon" src="alliances.png" alt="alliances">
            </div>
            <div class="col-12 col-sm-9 fs30 planning-label-container">
                <span class="planning-label"><span class="bold me-3">17h00:</span><span>Cérémonie laïque</span></span>
            </div>
            <div class="col-12 col-sm-3 mt-2 mb-2">
                <img class="planning-icon" src="champ.png" alt="champagne">
            </div>
            <div class="col-12 col-sm-9 fs30 planning-label-container">
                <span class="planning-label"><span class="bold me-3">18h00:</span><span>Vin d’honneur</span></span>
            </div>
            <div class="col-12 col-sm-3">
                <img class="planning-icon" src="alliances.png" alt="alliances">
            </div>
            <div class="col-12 col-sm-9 fs30 planning-label-container">
                <span class="planning-label"><span class="bold me-3">20h00:</span><span>Repas</span></span>
            </div>
            <div class="col-12 col-sm-3">
                <img class="planning-icon" src="disco.png" alt="disco">
            </div>
            <div class="col-12 col-sm-9 fs30 planning-label-container">
                <span class="planning-label"><span class="bold me-3">23h00:</span><span>Soirée dansante</span></span>
            </div>
            <img class="separator mt-2 mb-2" src="spot-separator.png" alt="separator" width="1000">
        </div>
    </div>
</div>